<div class="admin-date-time-picker" [class.is-open]="isOpen" [class.date-only]="!showTime">
  <button
    #pickerTrigger
    type="button"
    class="yt-picker-trigger"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="dialog"
    (click)="openPicker($event)"
  >
    <i nz-icon nzType="schedule"></i>
    <span [class.placeholder]="!displayValue">
      {{ displayValue || placeholder }}
    </span>
    @if (allowClear && value) {
      <span
        class="clear-button"
        role="button"
        tabindex="0"
        [attr.aria-label]="clearLabel"
        (click)="clear($event)"
        (keydown.enter)="clear($event)"
        (keydown.space)="clear($event)"
      >
        x
      </span>
    }
  </button>

  @if (isOpen) {
    <div class="yt-picker-popover" (click)="$event.stopPropagation()">
      <section class="calendar-panel">
        <div class="panel-heading">
          <div>
            <small>{{ dateLabel }}</small>
            <strong>{{ monthLabel }}</strong>
          </div>
          <div class="month-actions">
            <button type="button" (click)="previousMonth()" [attr.aria-label]="previousMonthLabel">
              &lsaquo;
            </button>
            <button type="button" (click)="nextMonth()" [attr.aria-label]="nextMonthLabel">
              &rsaquo;
            </button>
          </div>
        </div>

        <div class="weekday-grid">
          @for (weekday of weekdays; track weekday + $index) {
            <span>{{ weekday }}</span>
          }
        </div>

        <div class="calendar-grid">
          @for (day of calendarDays; track day.date.toISOString()) {
            <button
              type="button"
              class="calendar-day"
              [class.outside]="!day.inCurrentMonth"
              [class.today]="day.isToday"
              [class.selected]="day.isSelected"
              (click)="selectDate(day)"
            >
              {{ day.label }}
            </button>
          }
        </div>
      </section>

      @if (showTime) {
      <section class="time-panel">
        <div class="panel-heading">
          <div>
            <small>{{ timeLabel }}</small>
            <strong>{{ previewDate }}</strong>
          </div>
        </div>

        <div class="time-display">
          <div class="time-highlight" aria-hidden="true"></div>
          <div
            class="time-scroll-column"
            aria-label="Select hour"
            (scroll)="onTimeColumnScroll($event, 'hour')"
          >
            @for (hour of hourOptions; track hour.value) {
              <button
                type="button"
                class="time-scroll-option"
                [attr.data-value]="hour.value"
                [class.selected]="hour.value === draftValue.getHours()"
                (click)="setHour(hour.value)"
              >
                {{ hour.label }}
              </button>
            }
          </div>
          <span class="time-separator">:</span>
          <div
            class="time-scroll-column"
            aria-label="Select minute"
            (scroll)="onTimeColumnScroll($event, 'minute')"
          >
            @for (minute of minuteOptions; track minute.value) {
              <button
                type="button"
                class="time-scroll-option"
                [attr.data-value]="minute.value"
                [class.selected]="minute.value === draftValue.getMinutes()"
                (click)="setMinute(minute.value)"
              >
                {{ minute.label }}
              </button>
            }
          </div>
        </div>

        @if (showQuickOffsets) {
          <div class="quick-offset-area">
            <small>Quick offsets</small>
            <div class="quick-offset-strip" aria-label="Quick schedule offsets">
              @for (offset of quickOffsets; track offset.label) {
                <button
                  type="button"
                  class="quick-offset-chip"
                  [disabled]="disabled"
                  (click)="applyOffset(offset.minutes)"
                >
                  {{ offset.label }}
                </button>
              }
            </div>
          </div>
        }
      </section>
      }
    </div>
  }
</div>
